module.exports = __webpack_public_path__ + "static/media/dark-theme-overspeed-alt.044e7894.svg";